export default {
    badges: {
        countryId: 'Страна',
        cityId: 'Город',
        filter: 'Поисковый запрос',
        fromPrice: 'Цена от',
        toPrice: 'Цена до',
        serviceId: 'Подкатегория',
        serviceGroupId: 'Категория',
        orderBy: 'Сортировать по',
        sort: {
            createdAt_ASC: 'Дата по возрастанию',
            createdAt_DESC: 'Дата по убыванию',
            distance_ASC: 'Расстояние - рядом',
            priceRSD_ASC: 'Цена по возрастанию',
            priceRSD_DESC: 'Цена по убыванию',
            averageRating_ASC: 'Рейтинг по возрастанию',
            averageRating_DESC: 'Рейтинг по убыванию',
        },
    },
}
